<script setup lang="ts">
// 郵便番号インプット住所検索付き
interface Props {
  modelValue: string;
  id?: string;
  label?: string;
  label2?: string;
  placeholder?: string;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  id: "postnum",
  label: "郵便番号(ハイフン不要)",
  label2: "",
  placeholder: "郵便番号を入力",
  required: false,
});

const emit = defineEmits<{
  "update:modelValue": [modelValue: string];
  onSearch: [value: string];
}>();

if (props.required) {
  useValidatable();
}

const localValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

// 郵便番号のパターン
const pattern = /^[0-9]{7}$/;

const isError = ref(false);

function validate() {
  // 必須でなくて値がないとき
  if (!props.required && !props.modelValue) {
    isError.value = false;
    return true;
  }

  // (必須ではないが値はある || 必須で値がない || 必須で値がある) && テストに失敗
  if (!pattern.test(props.modelValue)) {
    isError.value = true;
    return false;
  }

  // テストに合格
  isError.value = false;
  return true;
}

// 郵便番号7桁から住所を補完
async function zipToAddress() {
  if (localValue.value) {
    const res = await $fetch("/api/zipcode", {
      query: { zipcode: localValue.value },
    });
    if (res && res.data) {
      emit("onSearch", res.data.pref + res.data.city + res.data.town);
    } else {
      alert("該当する住所が見つかりません");
    }
  } else {
    alert("郵便番号をご入力ください");
  }
}

watchDebounced(
  () => localValue.value,
  () => {
    // 値がないときは入力時のvalidateを行わない。submit時のvalidateは実行される
    if (localValue.value) {
      validate();
    }
  },
  { debounce: 500 },
);

defineExpose({ validate });
</script>

<template>
  <div ref="el" class="w-full tablet:max-w-[50%] relative pb-6">
    <FormInputLabel :id="id" :label="label" :label2="label2" />
    <div class="flex items-center relative">
      <MInput
        :id="id"
        v-model="localValue"
        class="w-4/5 rounded p-2"
        :placeholder="placeholder"
        :color="isError ? 'error' : 'normal'"
      />
      <button
        type="button"
        class="absolute right-0 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded"
        @click="zipToAddress"
      >
        検索
      </button>
    </div>
    <FormAlert
      v-if="isError"
      type="error"
      class="flex items-center absolute bottom-0"
    >
      <Icon class="mr-1 text-sm" size="18" name="mdi:alert-circle" />
      <span>郵便番号を入力してください</span>
    </FormAlert>
  </div>
</template>
